import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData,updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const RoomEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [itemOptions, setItemOptions] = useState([]); // Store available item options
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [amount, setAmount] = useState('');
    const [itemsList, setItemsList] = useState([]); // Store added items

    const [modalData, setModalData] = useState(null); // Modal data
    const [tableData, setTableData] = useState([]); // Table data for display


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }


    }, [isAuthenticated, companyId, branchId, token, logout]);


    useEffect(() => {
        fetchData('RoomApi', `/roomType/${id}`, token)
            .then((response) => {
                if (response?.responseCode === '1111') {
                    setFormData(response.response_data.Rooms);
                    setItemsList(response.response_data.RoomRateSlab);
                } else {
                    console.error('Unexpected response format:', response);
                }
            })
            .catch((error) => {
                console.error('Error fetching Rooms Details:', error);
            });
    }, [id]);

    const [selectedPaymentType, setSelectedPaymentType] = useState(true); // Default to Credit (true)
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BranchId: branchId,
        Name: '',
        Description: '',
        CreatedBy: userId,

    });

   
    // const submitData = async (e) => {
    //     e.preventDefault(); // Prevent form submission
    //     setIsLoading(true); // Set loading state

    //     // Combine Data for API
    //     const RoomRateVM = {
    //         Rooms: formData,
    //         RoomRateSlab: itemsList,
    //     };

    //     updateData('RoomApi', `${id}`, RoomRateVM, token)
    //         .then((response) => {
    //             console.log('Record updated successfully:', response.data);
    //             history.push('/RoomIndex');
    //         })
    //         .catch((error) => {
    //             console.error('Error updating record:', error);
    //         });

    // };
    const submitData = async (e) => {
        e.preventDefault(); // Prevent form submission
        setIsLoading(true); // Set loading state
    
        const RoomRateVM = {
            Rooms: formData,
            RoomRateSlab: itemsList,
        };
    
        console.log('Submitting data:', RoomRateVM);
    
        updateData('RoomApi', `${id}`, RoomRateVM, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/RoomIndex');
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.response || 'Failed to update record.';
                console.error('Error updating record:', errorMessage);
                alert(errorMessage);
            })
            .finally(() => {
                setIsLoading(false); // Reset loading state
            });
    };
    
    //FOR CHILD 
    const [SlabOptions, setSlabOptions] = useState([]);
    const [selectedSlabOption, setSelectedSlabOption] = useState(null);

    const fetchSlabOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            // const response = await fetchData('JournelEntryAPI', `${companyId}/${branchId}`, token);
            const response = await fetchData('SlabApi', `/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSlabOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };
    const handleSlabInputChange = (newValue) => newValue;
    // Handle Slab selection
    const handleSlabSelect = (selectedSlabOption) => {
        setSelectedSlabOption(selectedSlabOption);
        setFormData((prevData) => ({
            ...prevData,
            SlabId: selectedSlabOption ? selectedSlabOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedSlabOption) return;
    };


    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
            UpdatedBy: userId,
        }));
    };


    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,

        }));
    }, []);


    const addItemToList = () => {
        if (!selectedSlabOption) {
            setErrorMessage('Please select a slab option.');
            return;
        }

        const newItem = {
            slNo: itemsList.length + 1,
            Name: selectedSlabOption.label,
            SlabId: selectedSlabOption.value,
            Amount: parseFloat(formData.Amount), // Ensure Amount is a number
        };

        const updateddetails = [...itemsList, newItem];
        setItemsList(updateddetails);
        setErrorMessage('');
        setSelectedSlabOption(null);

        // Clear the Amount field
        setFormData((prev) => ({
            ...prev,
            Amount: '', // Reset Amount to an empty string
        }));
    };
    // Function to delete an item from the list
    const handleDelete = (slNo) => {
        const updatedList = itemsList.filter((item) => item.slNo !== slNo);
        setItemsList(updatedList);
    };
    const handleItemChange = (index, value) => {
        const updatedList = [...itemsList];
        updatedList[index].Amount = value;
        setItemsList(updatedList);
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>

                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '10px',
                        }}
                    >
                        CREATE Room
                    </h6>


                    <div className="flex mt-8 w-full sm:w-auto">

                        <Button
                            style={{
                                background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>UPDATE</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/RoomIndex",
                                state: { from: "/Room" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            style={{
                                background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                        >
                            <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-4"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        <div className="flex flex-wrap gap-x-4">

                            <div className="w-1/5  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Name">
                                    Room Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Name}
                                    name="Name"
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Description">
                                    Description
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Description}
                                    name="Description"
                                    onChange={handleChange}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '0.75%' }}>
                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Slab
                                    <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchSlabOptions}
                                    onInputChange={handleSlabInputChange}
                                    onChange={handleSlabSelect}
                                    value={selectedSlabOption}
                                />
                            </div>

                            <div className="w-1/3 mr-2" style={{ marginTop: '1.30%' }}>
                                <label
                                    className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                    htmlFor="MinimumStock"
                                >
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    onChange={handleChange}
                                    placeholder="Enter Amount"
                                    name="Amount"
                                    step="0.01"  // Allow decimals
                                    style={{ textAlign: 'right' }}
                                    min={0}
                                />
                            </div>


                            {/* Add Button */}
                            <div className="w-2/5 mr-2" style={{ marginTop: '3.90%' }}>
                                <button className="px-4 py-2 rounded" onClick={addItemToList}
                                    style={{
                                        color: 'white',
                                        fontWeight: 'bolder',
                                        textTransform: 'none',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                        maxHeight: '35px',
                                        marginLeft: '6px',
                                        backgroundColor: '#D3F1DF'
                                    }}>
                                    <span style={{ marginTop: '2%', color: 'black' }}>+ ADD</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Section: Table */}
                <div className="flex-1 p-4">
                    <div className="rounded-lg shadow overflow-hidden" style={{ backgroundColor: '#EDDFE0', marginTop: '-1.95%' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ textAlign: 'center', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}>
                                            SELECTED SLAB LIST
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ padding: '4px' }}>Sl.No</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Slab</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Amount</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemsList.length > 0 ? (
                                        itemsList.map((raterelation, index) => (
                                            <TableRow key={index}>
                                                <TableCell style={{ padding: '3px' }}>{index + 1}</TableCell>
                                                <TableCell style={{ padding: '3px' }}>{raterelation.Name}</TableCell>

                                                <TableCell style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={raterelation.Amount}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FFCF96', textAlign: 'right' }}
                                                        min="0"
                                                        name="Amount"
                                                        onChange={(e) => handleItemChange(index, parseFloat(e.target.value))}
                                                    />
                                                </TableCell>

                                                <TableCell style={{ padding: '3px' }}>
                                                    <IconButton color="error" onClick={() => handleDelete(raterelation.slNo)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No Items Selected
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>

        </Fragment >
    );
};


export default RoomEdit;
